module.exports = __webpack_public_path__ + "static/media/drag.b4f8cc3a.gif";